import { formatDate, parseDate } from "../../utils/parsers.js";
import { useDispatch, useSelector } from "react-redux";

import CaseTable from "./CaseTable";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import React from "react";
import Row from "react-bootstrap/Row";
import Spinner from "react-bootstrap/Spinner";
import Table from "react-bootstrap/Table";

export default function CaseList({ micro_id }) {
  const contact_list = useSelector((state) => state.patient.contact_list);
  console.log('contact_list', contact_list);
  var wards = Object.keys(contact_list);
  console.log(wards.every(ward => contact_list[ward].length === 0))
  console.log("wards", wards)
  console.log('state.patient', useSelector((state) => state.patient));
  var first_pos_date = useSelector((state) => state.patient?.patient?.pt?.first_positive);
  var first_pos_ward = useSelector((state) => state.patient?.patient?.pt?.ward_first_positive);
  var most_recent_ward = useSelector((state) => state.patient?.patient?.pt?.most_recent_ward);
  var most_recent_adm_start = useSelector((state) => state.patient?.patient?.pt?.most_recent_adm_start);
  var most_recent_adm_end = useSelector((state) => state.patient?.patient?.pt?.most_recent_adm_end);
  const ptId = useSelector((state) => state.patient?.micro_id);
  const ptObj = useSelector((state) => state.patient?.patient);

  const survey = useSelector((state) => state.survey);
  const activeCase = useSelector((state) => state.survey.activeCase);

  const survey_mode = useSelector((state) => state.survey.surveyHistory[activeCase?.micro_id]);

  const srceNames = (sources) => {
    return sources.flatMap((item) =>
      item.sources.map((source) => `${source.firstname} ${source.surname}`)
    );
  };

  var relevant_index_ward = first_pos_ward? first_pos_ward : most_recent_ward;

  // only display patients from wards where the index patient first tested positive
  const filteredContacts =
    relevant_index_ward && contact_list?.[relevant_index_ward]?.length > 0
      ? { [relevant_index_ward]: contact_list[relevant_index_ward] }
      : {};
  
  // console.log('filteredContacts', filteredContacts);
  // console.log('filtered contacts is empty:', Object.keys(filteredContacts).length === 0);
  // console.log('wards.length', wards.length === 0);
  // console.log('a', wards.every(ward => contact_list[ward].length === 0))
  // console.log('first_pos_ward', first_pos_ward);
  // console.log('most_recent_ward', most_recent_ward);

  return (
    <>
      {(ptId !== micro_id) |
      ((contact_list === undefined) | (ptObj.pt === undefined)) ? (
        <Spinner animation="border" />
      ) : (
        <Container>
          <Row>
            <Col md={12}>
              {relevant_index_ward === null ? (
                <div>This patient tested positive outside the hospital.
                  <hr style={{marginBottom: 0}}></hr>
                </div>
                
              ) : (
                <div>
                  This patient tested positive on ward <span style={{fontWeight: 600}}>{relevant_index_ward}</span> on <span style={{fontWeight: 600}}>{formatDate(parseDate(first_pos_date))}</span>. <br></br><br></br>They were admitted to the hospital on <span style={{fontWeight: 600}}>{most_recent_adm_start ? formatDate(parseDate(most_recent_adm_start)) : "Unknown"}</span>.
                  <hr style={{marginBottom: 0}}></hr>
                </div>
              )}
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div>
                {wards.length === 0 && relevant_index_ward === null ? (
                  <>
                    <span style={{fontWeight: 600}}>This patient has not been in the hospital in the last <u>84 days</u></span>.
                  </>
                ) : wards.length === 0 || wards.every(ward => contact_list[ward].length === 0) || Object.keys(filteredContacts).length === 0 ? (
                  <>
                    {/* This patient has been to the ward(s) <strong>{wards.join(", ")}</strong>,  */}
                    <span style={{fontWeight: 600}}>No other patients have tested positive in the same ward {relevant_index_ward} in the last <u>84 days</u></span>.
                  </>
                ) : (
                  <>
                    {/* This patient has been to the ward(s) <strong>{wards.join(", ")}</strong>.  */}
                    <span style={{fontWeight: 600}}>The following patient(s) also tested positive in the same ward {relevant_index_ward} in the last <u>84 days</u></span>:
                  </>
                )}
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              {wards.length === 0 || wards.every(ward => contact_list[ward].length === 0) || Object.keys(filteredContacts).length === 0 ? null : (
                <CaseTable
                  pt_name={ptObj.pt.name}
                  contacts={filteredContacts}
                  sources={srceNames(ptObj.source_list)}
                  survey_mode={survey_mode}
                />
              )}
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
}
